export default __webpack_public_path__ + "static/media/Artboard 50.15840478.png";